import type { Purchaser } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { UpdatePurchaserDTO } from "@src/domain/dto/purchasers";

export class UpdatePurchaserUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(params: UpdatePurchaserDTO): Promise<Purchaser> {
    return this.purchaserRepository.updatePurchaser(params);
  }
}
